<div class="animate__animated animate__fadeInRight">
    <br />
  
    <div class="col">
      <mat-card class="mat_card_general">
        <h1 class>Modulo de estado Civil</h1>
      </mat-card>
    </div>
  
    <br />
    <mat-card class="mat-elevation-z5 mat_card_general_content">
      <app-agregar-estado-civil
        (onDebounce)="actualizarTabla($event)"
      ></app-agregar-estado-civil>
      <br />
      <app-lista-estado-civil
        (onDebounce)="actualizarTabla($event)"
        [estadoCivil_List]="estadoCivil"
      ></app-lista-estado-civil>
    </mat-card>
    <hr />
  </div>
  